export default __webpack_public_path__ + "static/media/money.39265285.png";